import { AnchorHardwareListResponseSchema, AnchorPointAssignmentBodySchema, AnchorPointResponseSchema, BaseResponseSchema, DeploymentAnchorConfigListResponseSchema, DeploymentEngineerSitesResponseSchema, DeploymentSiteScopeQuerySchema, EventsQuerySchema, EventsResponseSchema, FloorPlanAnchorPointParamsSchema, FloorPlanFloorParamsSchema, FloorPlanListResponseSchema, FloorPlanSiteParamsSchema, FloorPlanUpdateBodySchema, FloorPlanUpdateResponseSchema, LocationIntegrationDeleteResponseSchema, LocationIntegrationHealthResponseSchema, LocationIntegrationPollNowResponseSchema, LocationIntegrationRequestSchema, LocationIntegrationResponseSchema, LocationIntegrationSiteParamsSchema, LocationIntegrationTestRequestSchema, LocationIntegrationTestResponseSchema, LocationIntegrationUpdateRequestSchema, LocationIntegrationWizardPreviewResponseSchema, LocationIntegrationWizardRunResponseSchema, ProviderOperationsDashboardResponseSchema, ProviderSiteTelemetrySettingsPatchBodySchema, ProviderSiteTelemetrySettingsResponseSchema, ProviderTenantSitesResponseSchema, GrantIdParamsSchema, SiteAccessGrantCreateBodySchema, SiteAccessGrantListResponseSchema, SiteAccessGrantResponseSchema, SiteAccessGrantUpdateBodySchema, SiteAnchorHealthListQuerySchema, SiteAnchorHealthListResponseSchema, SiteGatewayListResponseSchema, SiteGatewayParamsSchema, SiteGatewayResponseSchema, SiteTagFleetListQuerySchema, SiteTagFleetListResponseSchema, SiteTagFleetSiteParamsSchema, SiteTagFleetTagsListQuerySchema, SiteTagFleetTagsListResponseSchema, TagCurrentStateListResponseSchema, UwbDeploymentStatusResponseSchema, } from '../../schemas.js';
import { EmptyJsonBodySchema, LocationIntegrationWizardRunQuerySchema, LocationProviderTenantQuerySchema, } from '../../schemas/location-provider.schemas.js';
import { TenantIdParamSchema } from '../../schemas/params.js';
const locationBase = { base: 'location' };
const supportViewerEventsQuerySchema = LocationProviderTenantQuerySchema.merge(EventsQuerySchema);
/** REST contract for `spatial-service/.../provider/location-integration*.routes.ts`. */
export const providerLocationIntegrationContract = {
    getIntegration: {
        method: 'GET',
        path: '/provider/sites/:siteId/location-integration',
        pathParams: LocationIntegrationSiteParamsSchema,
        query: LocationProviderTenantQuerySchema,
        response: LocationIntegrationResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get location integration',
        ...locationBase,
    },
    testIntegration: {
        method: 'POST',
        path: '/provider/sites/:siteId/location-integration/test',
        pathParams: LocationIntegrationSiteParamsSchema,
        body: LocationIntegrationTestRequestSchema,
        response: LocationIntegrationTestResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to test location integration',
        ...locationBase,
    },
    getIntegrationHealth: {
        method: 'GET',
        path: '/provider/sites/:siteId/location-integration/health',
        pathParams: LocationIntegrationSiteParamsSchema,
        query: LocationProviderTenantQuerySchema,
        response: LocationIntegrationHealthResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get location integration health',
        ...locationBase,
    },
    createIntegration: {
        method: 'POST',
        path: '/provider/sites/:siteId/location-integration',
        pathParams: LocationIntegrationSiteParamsSchema,
        body: LocationIntegrationRequestSchema,
        response: LocationIntegrationResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to create location integration',
        ...locationBase,
    },
    updateIntegration: {
        method: 'PUT',
        path: '/provider/sites/:siteId/location-integration',
        pathParams: LocationIntegrationSiteParamsSchema,
        body: LocationIntegrationUpdateRequestSchema,
        response: LocationIntegrationResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to update location integration',
        ...locationBase,
    },
    deleteIntegration: {
        method: 'DELETE',
        path: '/provider/sites/:siteId/location-integration',
        pathParams: LocationIntegrationSiteParamsSchema,
        query: LocationProviderTenantQuerySchema,
        response: LocationIntegrationDeleteResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to delete location integration',
        ...locationBase,
    },
    pollIntegrationNow: {
        method: 'POST',
        path: '/provider/sites/:siteId/location-integration/poll',
        pathParams: LocationIntegrationSiteParamsSchema,
        query: LocationProviderTenantQuerySchema,
        response: LocationIntegrationPollNowResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to poll location integration',
        ...locationBase,
    },
    previewWizard: {
        method: 'GET',
        path: '/provider/sites/:siteId/location-integration/wizard/preview',
        pathParams: LocationIntegrationSiteParamsSchema,
        query: LocationProviderTenantQuerySchema,
        response: LocationIntegrationWizardPreviewResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to preview location integration wizard',
        ...locationBase,
    },
    runWizard: {
        method: 'POST',
        path: '/provider/sites/:siteId/location-integration/wizard/run',
        pathParams: LocationIntegrationSiteParamsSchema,
        query: LocationIntegrationWizardRunQuerySchema,
        response: LocationIntegrationWizardRunResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to run location integration wizard',
        ...locationBase,
    },
    syncTopology: {
        method: 'POST',
        path: '/provider/sites/:siteId/location-integration/sync',
        pathParams: LocationIntegrationSiteParamsSchema,
        query: LocationProviderTenantQuerySchema,
        response: LocationIntegrationWizardRunResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to sync location integration topology',
        ...locationBase,
    },
    getProviderTelemetrySettings: {
        method: 'GET',
        path: '/provider/sites/:siteId/telemetry-settings',
        pathParams: LocationIntegrationSiteParamsSchema,
        query: LocationProviderTenantQuerySchema,
        response: ProviderSiteTelemetrySettingsResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get provider site telemetry settings',
        ...locationBase,
    },
    putProviderTelemetrySettings: {
        method: 'PUT',
        path: '/provider/sites/:siteId/telemetry-settings',
        pathParams: LocationIntegrationSiteParamsSchema,
        query: LocationProviderTenantQuerySchema,
        body: ProviderSiteTelemetrySettingsPatchBodySchema,
        response: ProviderSiteTelemetrySettingsResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to update provider site telemetry settings',
        ...locationBase,
    },
    getTenantSites: {
        method: 'GET',
        path: '/provider/tenants/:tenantId/sites',
        pathParams: TenantIdParamSchema,
        response: ProviderTenantSitesResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to list provider tenant sites',
        ...locationBase,
    },
};
/** REST contract for `spatial-service/.../provider/uwb-deployment.routes.ts`. */
export const providerLocationDeploymentContract = {
    listSites: {
        method: 'GET',
        path: '/provider/location-deployment/sites',
        response: DeploymentEngineerSitesResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to list deployment sites',
        ...locationBase,
    },
    listFloorPlans: {
        method: 'GET',
        path: '/provider/location-deployment/sites/:siteId/floor-plans',
        pathParams: FloorPlanSiteParamsSchema,
        query: DeploymentSiteScopeQuerySchema,
        response: FloorPlanListResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to list deployment floor plans',
        ...locationBase,
    },
    updateFloorPlan: {
        method: 'PUT',
        path: '/provider/location-deployment/sites/:siteId/floor-plans/:floorId',
        pathParams: FloorPlanFloorParamsSchema,
        query: DeploymentSiteScopeQuerySchema,
        body: FloorPlanUpdateBodySchema,
        response: FloorPlanUpdateResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to update deployment floor plan',
        ...locationBase,
    },
    getAnchorsCurrent: {
        method: 'GET',
        path: '/provider/location-deployment/sites/:siteId/anchors/current',
        pathParams: FloorPlanSiteParamsSchema,
        query: DeploymentSiteScopeQuerySchema,
        response: TagCurrentStateListResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get deployment anchor state',
        ...locationBase,
    },
    getAnchorsConfig: {
        method: 'GET',
        path: '/provider/location-deployment/sites/:siteId/anchors/config',
        pathParams: FloorPlanSiteParamsSchema,
        query: DeploymentSiteScopeQuerySchema,
        response: DeploymentAnchorConfigListResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get deployment anchor config',
        ...locationBase,
    },
    updateAnchorPointAssignment: {
        method: 'PATCH',
        path: '/provider/location-deployment/sites/:siteId/floor-plans/:floorId/anchor-points/:anchorPointId/assignment',
        pathParams: FloorPlanAnchorPointParamsSchema,
        query: DeploymentSiteScopeQuerySchema,
        body: AnchorPointAssignmentBodySchema,
        response: AnchorPointResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to update deployment anchor point assignment',
        ...locationBase,
    },
    listSiteGateways: {
        method: 'GET',
        path: '/provider/location-deployment/sites/:siteId/gateways',
        pathParams: FloorPlanSiteParamsSchema,
        query: DeploymentSiteScopeQuerySchema,
        response: SiteGatewayListResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to list deployment site gateways',
        ...locationBase,
    },
    assignSiteGateway: {
        method: 'PUT',
        path: '/provider/location-deployment/sites/:siteId/gateways/:serialNumber',
        pathParams: SiteGatewayParamsSchema,
        query: DeploymentSiteScopeQuerySchema,
        body: EmptyJsonBodySchema,
        response: SiteGatewayResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to assign deployment site gateway',
        ...locationBase,
    },
    removeSiteGateway: {
        method: 'DELETE',
        path: '/provider/location-deployment/sites/:siteId/gateways/:serialNumber',
        pathParams: SiteGatewayParamsSchema,
        query: DeploymentSiteScopeQuerySchema,
        response: BaseResponseSchema,
        responseStyle: 'void',
        errorMessage: 'Failed to remove deployment site gateway',
        ...locationBase,
    },
};
/** REST contract for `spatial-service/.../provider/location-operations.routes.ts`. */
export const providerLocationOperationsContract = {
    getDashboard: {
        method: 'GET',
        path: '/provider/location-operations/dashboard',
        response: ProviderOperationsDashboardResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get provider operations dashboard',
        ...locationBase,
    },
    getUwbStatus: {
        method: 'GET',
        path: '/provider/location-operations/uwb-status',
        response: UwbDeploymentStatusResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get UWB deployment status',
        ...locationBase,
    },
    listSiteAnchorHealth: {
        method: 'GET',
        path: '/provider/location-operations/site-anchor-health',
        query: SiteAnchorHealthListQuerySchema,
        response: SiteAnchorHealthListResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to list site anchor health',
        ...locationBase,
    },
    listSiteTagFleet: {
        method: 'GET',
        path: '/provider/location-operations/site-tag-fleet',
        query: SiteTagFleetListQuerySchema,
        response: SiteTagFleetListResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to list site tag fleet',
        ...locationBase,
    },
    listSiteTagFleetTags: {
        method: 'GET',
        path: '/provider/location-operations/site-tag-fleet/:tenantId/:siteId/tags',
        pathParams: SiteTagFleetSiteParamsSchema,
        query: SiteTagFleetTagsListQuerySchema,
        response: SiteTagFleetTagsListResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to list site tag fleet tags',
        ...locationBase,
    },
};
/** REST contract for `spatial-service/.../provider/location-support.routes.ts`. */
export const providerLocationSupportContract = {
    getTagsCurrent: {
        method: 'GET',
        path: '/provider/location-support/sites/:siteId/tags/current',
        pathParams: LocationIntegrationSiteParamsSchema,
        query: LocationProviderTenantQuerySchema,
        response: TagCurrentStateListResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get support viewer tags',
        ...locationBase,
    },
    getAnchorsCurrent: {
        method: 'GET',
        path: '/provider/location-support/sites/:siteId/anchors/current',
        pathParams: LocationIntegrationSiteParamsSchema,
        query: LocationProviderTenantQuerySchema,
        response: AnchorHardwareListResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get support viewer anchors',
        ...locationBase,
    },
    listFloorPlans: {
        method: 'GET',
        path: '/provider/location-support/sites/:siteId/floor-plans',
        pathParams: LocationIntegrationSiteParamsSchema,
        query: LocationProviderTenantQuerySchema,
        response: FloorPlanListResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to list support viewer floor plans',
        ...locationBase,
    },
    getSiteEvents: {
        method: 'GET',
        path: '/provider/location-support/sites/:siteId/events',
        pathParams: LocationIntegrationSiteParamsSchema,
        query: supportViewerEventsQuerySchema,
        response: EventsResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get support viewer events',
        ...locationBase,
    },
};
/** REST contract for `spatial-service/.../provider/site-access-grants.routes.ts`. */
export const providerSiteAccessGrantsContract = {
    list: {
        method: 'GET',
        path: '/provider/site-access-grants',
        response: SiteAccessGrantListResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to list site access grants',
        ...locationBase,
    },
    create: {
        method: 'POST',
        path: '/provider/site-access-grants',
        body: SiteAccessGrantCreateBodySchema,
        response: SiteAccessGrantResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to create site access grant',
        ...locationBase,
    },
    update: {
        method: 'PATCH',
        path: '/provider/site-access-grants/:grantId',
        pathParams: GrantIdParamsSchema,
        body: SiteAccessGrantUpdateBodySchema,
        response: SiteAccessGrantResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to update site access grant',
        ...locationBase,
    },
    revoke: {
        method: 'DELETE',
        path: '/provider/site-access-grants/:grantId',
        pathParams: GrantIdParamsSchema,
        response: SiteAccessGrantResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to revoke site access grant',
        ...locationBase,
    },
};
//# sourceMappingURL=provider-location.contract.js.map